export const ReactionTypes = [
  {text: "like", label: "Like", icon: "like", color: "rgb(96, 146, 247)"},
  {text: "heart", label: "Love", icon: "heart", color: "rgb(226, 94, 107)"},
  {text: "haha", label: "Haha", icon: "haha", color: "rgb(240, 173, 78)"},
  {text: "wow", label: "Wow", icon: "wow", color: "rgb(240, 173, 78)"},
  {text: "sad", label: "Sad", icon: "sad", color: "rgb(240, 173, 78)"},
  {text: "angry", label: "Angry", icon: "angry", color: "rgb(234, 133, 114)"}
]

